module.exports = __webpack_public_path__ + "static/media/logo.4b316552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 154
// module chunks = 1